var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,{tag:"component",staticClass:"header-menu-item-placeholder",style:({
    width: _vm.widthComputed,
    height: _vm.heightComputed,
    '--sk-bg-color': _vm.bgColor,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }